import { OrderEvent } from "@spartacus/order/root";

export class SsabOrderEvent extends OrderEvent {
  }